import Validation from '../../../Utilities/ValidationHelper/Validation';

export default class ValidateContracts extends Validation {
  static affiliate = (value) => {
    const result = { ...ValidateContracts.defaultReturn };
    if (value.trim() === '') {
      result.valid = false;
      result.message = 'Value for Affiliate can not be empty.';
    }
    return result;
  };

  static site = (value) => {
    const result = { ...ValidateContracts.defaultReturn };
    if (!+value) {
      result.valid = false;
      result.message = 'Please select a vertical.';
    }
    return result;
  };

  static contract = (value) => {
    const result = { ...ValidateContracts.defaultReturn };

    if (
      !value ||
      typeof value !== 'object' ||
      !value.contract_id ||
      !value.contract_name
    ) {
      result.valid = false;
      result.message = 'Contract invalid - both ID and name are required';
    } else if (value.contract_id.length !== 36) {
      result.valid = false;
      result.message = 'Contract ID must be 36 characters';
    } else if (value.contract_name.trim().length < 3) {
      result.valid = false;
      result.message = 'Contract name must be at least 3 characters';
    }

    return result;
  };
}
